import script from "./BaseCalculatorBranchIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCalculatorBranchIcon.vue?vue&type=script&setup=true&lang=ts"

import "./BaseCalculatorBranchIcon.vue?vue&type=style&index=0&id=013b4254&lang=scss"

const __exports__ = script;

export default __exports__